import * as React from 'react';

function ModelItem(props) {
    return (
        <figure className='commonItemContainer modelItem' onClick={props.onModelClick}>
            <img className="modelImg" src={props.dataProvider.iconPath} alt={props.dataProvider.name}/>
            <figcaption className="textDescription">{props.dataProvider.name}</figcaption>
        </figure>
    );
}

export default ModelItem;